export default "__VITE_ASSET__c4d67d8c__"